import React from "react";
import ConfirmarCadatroPix from "../../../components/acesso-rapido/pix/confirmar-cadatro-pix/ConfirmarCadatroPix";

export default function () {
  return <ConfirmarCadatroPix />;
}
